export default __webpack_public_path__ + "static/media/user.b5c50ee0.svg";